export default __webpack_public_path__ + "static/media/trash-can.ce6f7954.svg";